import { render, staticRenderFns } from "./FocusAreasProjectOne-View.vue?vue&type=template&id=622ab9fe&scoped=true&"
import script from "./FocusAreasProjectOne-View.vue?vue&type=script&setup=true&lang=js&"
export * from "./FocusAreasProjectOne-View.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ab9fe",
  null
  
)

export default component.exports